/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2023
 * @flow
 */

import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import {
  Box,
  IconButton,
  ButtonGroup,
  Button,
} from '@material-ui/core';
import {
  Menu as MenuIcon,
  Add as AddIcon,
  ImportExport as DragIndicatorIcon,
} from '@material-ui/icons';
import useStyles from './useStyles';

const WaitlistHeader = ({
  enableDrag,
  onToggleEnableDrag,
  bookingStatus,
  onChangeBookingStatus,
  onAddGuest,
  bookingCount,
  onOpenMenu,
}) => {
  const { labelsData } = useSelector(state => state);
  const labels = labelsData?.labels;
  const classes = useStyles();

  const BookingStatuses = [
    { label: labels.WAITLIST_WAITLIST, statusId: 0, key: 'waitlist' },
    { label: labels.WAITLIST_SEATED, statusId: 7, key: 'seated' },
    { label: labels.WAITLIST_CANCELLED, statusId: 9, key: 'cancelled' },
  ];

  return (
    <React.Fragment>
      <Box className={classes.headerBox}>
        <IconButton className={classes.iconButton} onClick={onOpenMenu}>
          <MenuIcon />
        </IconButton>
        <Button
          size='medium'
          variant="contained"
          className={classes.button}
          startIcon={<AddIcon />}
          onClick={onAddGuest}
        >
          {labels.WAITLIST_ADD_GUEST}
        </Button>
        <IconButton onClick={onToggleEnableDrag} className={cn(classes.iconButton, classes.dragButton, classes.rightAlign, { [classes.dragEnabled]: !enableDrag })}>
          <DragIndicatorIcon />
        </IconButton>
      </Box>
      <Box className={classes.buttonsBox}>
        <ButtonGroup size="medium" aria-label="waitlist-option" fullWidth>
          {BookingStatuses.map(eachStatus =>
            <Button
              key={`status-${eachStatus.label}-id-${eachStatus.statusId}`}
              onClick={() => onChangeBookingStatus(eachStatus)}
              className={cn(classes.buttonGrpBtn, { [classes.selectButtonGrp]: eachStatus.statusId === bookingStatus?.statusId })}
            >
              {eachStatus.label} ({bookingCount[eachStatus.key]})
            </Button>
          )}
        </ButtonGroup>
      </Box>
    </React.Fragment>
  );
};

export default WaitlistHeader;
